<template>
  <div class="form-container has-text-left">
    <h1 class="is-size-5 has-text-weight-semibold">Select Competing Division(s)</h1>
    <p>You can select as many divisions as you want.</p>
    <div class="notification reminder">
      <p><b>Beginner</b>: White - Blue Belts</p>
      <p><b>Advanced</b>: Purple - Black Belts</p>
    </div>
    <div class="columns">
      <div class="column divisions-wrapper">
        <DivisionItem
          v-for="division in selectedDivisions"
          :key="division._id"
          :division="division"
          @toggleDivision="toggleDivision"
        />
      </div>
    </div>
    <div class="level is-mobile">
      <a
        href="#"
        :class="{ 'is-loading': isSubmitting }"
        class="button is-warning is-fullwidth level-item dynamic-cta"
        :disabled="!isValid || isSubmitting"
        @click.prevent="proceedToPayment"
      >
        <span class="has-text-weight-bold">Next</span>
        <small v-if="isValid">({{ selectedCount }} division{{ selectedCount > 1 ? 's' : ''}})</small>
      </a>
    </div>
  </div>
</template>

<script>
import DivisionItem from '@/components/registerFormSteps/DivisionItem'

export default {
  name: 'SelectDivisions',
  components: {
    DivisionItem
  },
  props: {
    rank: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      selectedDivisions: [],
      //  State
      isSubmitting: false
    }
  },
  computed: {
    selectedCount () {
      return this.selectedDivisions.filter(d => { return d.selected > 0 }).length
    },
    isValid () {
      return this.selectedCount > 0
    }
  },
  mounted () {
    this.$store
      .dispatch('register/GET_DIVISION', {})
      .then(res => {
        res.data.divisions.map(division => {
          division.selected = false
        })

        return res.data.divisions
      })
      .then(data => {
        this.selectedDivisions = data
      })
  },
  methods: {
    toggleDivision (params) {
      const i = this.selectedDivisions.findIndex(d => {
        return d._id === params._id
      })

      let d = this.selectedDivisions[i]
      d.selected = params.selected
      this.selectedDivisions.splice(i, 1, d)
    },
    proceedToPayment () {
      this.isSubmitting = true

      // Build items for Stripe payment
      let participatingDivisions = []
      let divisionNames = []
      let total = 0
      let metadata = {}
      let description = 'Global Martial Arts World Championships registration.'

      this.selectedDivisions
        .filter(d => { return d.selected })
        .map(item => {
          metadata[item.name] = `$${Math.round(item.price / 1000 * 10).toFixed(2)}`

          item['hasSubmitted'] = false

          participatingDivisions.push(item)

          divisionNames.push(item.name)

          total += item.price
        })

      this.$store.commit('register/saveDivisions', participatingDivisions)

      this.$store
        .dispatch('register/UPDATE_DIVISIONS', {
          email: this.$store.getters.email,
          divisions: participatingDivisions,
          eventId: this.$store.state.currentEvent._id
        })
        .then(divRes => {
          if (divRes.status === 200) {
            const stripeDataObj = {
              email: this.$store.getters['register/email'],
              amount: total,
              description: description,
              metadata: metadata,
              divisionNames: divisionNames
            }

            this.$store
              .dispatch('register/GENERATE_STRIPE_INTENT', stripeDataObj)
              .then(stripeRes => {
                this.$store.commit('register/saveStripeClientSecret', stripeRes.data.client_secret)
              })
              .then(() => {
                this.$router.push({ name: 'register-confirmation' })
              })
              .catch(err => {
                this.$toasted.error('Stripe error occurred')
                console.log(err)
              })
          } else {
            this.$toasted.error('Server error occurred')
          }
        })
        .catch(err => {
          this.$toasted.error('Server error occurred')
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
  .notification{
    &.reminder{
      padding: .5em 1em;
      margin-top: .5em;
      background: $yellow;
      color: $primary-color;
      border: 2px solid $primary-color;
    }
  }
  .dynamic-cta{
    display: flex;
    flex-direction: column;
    height: auto;
    > small{
      font-weight: normal!important;
    }
  }
</style>
